import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getLetianStaff, getLetianStaffTemp } from '../../actions/qtActions';
import { getChildBranchList, getUserPreference } from "../../utilities/common";
import { getBranchList } from '../../actions/commonAction';
import BasicTransfer from './BasicTransfer';
import AdvancedTransfer from './AdvancedTransfer';

import { 
    Dialog, DialogTitle, DialogContent, 
    Radio, RadioGroup, 
    FormControlLabel, FormControl,  
    Tooltip, CircularProgress
} from '@material-ui/core';

import { handleQuickTransfer, openQuickTransfer } from '../../reducers/uiSlice';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { getServicePoint } from '../../actions/dropOffActions';
import CrossWarehouseTransfer from './CrossWarehouseTransfer';
import { useToken } from '../../utilities/hooks';

export const useStyles = makeStyles( (theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        minHeight: '60vh'
    },
    batchesStyle: {
        marginTop: 10,
        padding: '10 5'
    },
    driverStyle: {
        marginTop: 20,
        padding: '10 5'
    },
    textfieldBatchStyle: {
        width: '100%'
    },
    titleStyle: {
        marginBottom: 10
    },
    loadingStyle: {
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    subBatchStyle: {
        display: 'flex',
        width: '100%'
    }
}) );

const QuickTransfer = () => {
    const classes = useStyles();
    const {t} = useTranslation('quickTransfer');
    const dispatch = useDispatch();
    let userPref = getUserPreference();
    const tokenContents = useToken();

    const authorizedWarehouses = tokenContents.warehouse;

    const openModal = useSelector(openQuickTransfer);
    const branchesList = useSelector(state => state.common.branches);
    // const quickTransfer = useSelector(state => state.quickTransfer);

    const [quickTransferType, setQuickTransferType] = useState('basic');
    const [isLoading, setLoading] = useState(true);
    const [searchList, setSearchList] = useState([]);
    const [driverListTemp, setDriverListTemp] = useState([]);
    const [branches, setBranches] = useState([]);
    const [childBranchList, setChildBranchList] = useState([]);

    useEffect(() => { (async () => {
        if (openModal) {
            dispatch(getServicePoint(userPref.userCity));
            let letianStaff = dispatch(getLetianStaff(userPref.userCity));
            let branchList = dispatch(getBranchList());
            let letianStaffTemp = Promise.resolve([]);
            
            if (userPref.userCity === 2) {
                letianStaffTemp = dispatch(getLetianStaffTemp(14));
            } else if (userPref.userCity === 14) {
                letianStaffTemp = dispatch(getLetianStaffTemp(2));
            }

            try {
                let result = await Promise.all([letianStaff, branchList, letianStaffTemp]);
                setSearchList(result[0]);
                setBranches(result[1]);
                setDriverListTemp(result[2]);
                setLoading(false);
                setChildBranchList(getChildBranchList(userPref.userCity, result[1]));
            } catch (error) {
                console.error(error);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }) ()}, [openModal]);


    return (<>

        <Dialog 
            onClose={handleClose} 
            open={openModal}
            fullWidth
            maxWidth='sm'
        >

            <DialogTitle>
                {t('title_quick_transfer')}

                <Tooltip title={t('common:cancel')} aria-label='cancel' style={{float: 'right'}}>
                    <CloseIcon onClick={handleClose}/>
                </Tooltip>
            </DialogTitle>

            <FormControl>
                <RadioGroup row 
                    defaultValue='basic' 
                    onChange={ (e) => {setQuickTransferType(e.target.value)} } 
                    style={{ marginLeft: 20 }}
                >
                    <FormControlLabel value='basic' control={<Radio/>} label={t('basic')}/>
                    <FormControlLabel value='advanced' control={<Radio/>} label={t('advanced')}/>
                    {
                        childBranchList &&
                        childBranchList.length > 0 &&
                        <FormControlLabel value='cross-warehouse' control={<Radio/>} label={t('cross-warehouse')}/>
                    }
                </RadioGroup>
            </FormControl>

            <DialogContent dividers className={classes.root}>
                {(() => {
                    if (isLoading) {
                        return <CircularProgress className={classes.loadingStyle} color='secondary'/>;
                    } else 
                    switch (quickTransferType) {
                        case 'basic':
                            return (
                                <BasicTransfer classes={classes}
                                    dispatch={dispatch}
                                    userCity={userPref.userCity}
                                    searchList={searchList}
                                    driverListTemp={driverListTemp}
                                    branches={
                                        branches &&
                                        branches.filter(
                                            (branch) => (authorizedWarehouses.includes(branch.id))
                                        )
                                    }
                                />
                            );
                        case 'advanced':
                            return (
                                <AdvancedTransfer classes={classes}
                                    dispatch={dispatch}
                                    userCity={userPref.userCity}
                                    searchList={searchList}
                                    driverListTemp={driverListTemp}
                                />
                            );
                        case 'cross-warehouse':
                            return (
                                <CrossWarehouseTransfer 
                                    classes={classes}
                                    dispatch={dispatch}
                                    userCity={userPref.userCity}
                                    childBranchList={childBranchList}
                                />
                            );
                        default:
                            return null;
                    }
                }) ()}
            </DialogContent>

        </Dialog>

    </>);

    function handleClose() {
        setQuickTransferType('basic');
        setLoading(true);
        dispatch(handleQuickTransfer(false));
    }
}

export default QuickTransfer;